<template>
  <div id="app" >

      <vm-back-top :duration="100"></vm-back-top>
    <vue-snotify></vue-snotify>
    <navpanel v-if="$auth.check()"></navpanel> 
    <navbar></navbar>
    
    

    <div class="px-content p-0 p-sm-3 mt-5">
      <transition name="fade" mode="out-in">
      <router-view><router-view></router-view></router-view>
      </transition>
    </div>
    <audio id="chatAudio"><source src="https://www.sci-space.com/uploads/files/notify.ogg" type="audio/ogg"><source src="https://www.sci-space.com/uploads/files/notify.mp3" type="audio/mpeg"><source src="https://www.sci-space.com/uploads/files/notify.wav" type="audio/wav"></audio>
      <div id="start_place" style="display: none;"></div>
  <div class="panel-body " id="message_block" style='display:none;'>
      <div id="new_message" class="message-box"><textarea></textarea></div>
    <br><div  class="pull-right"><b-button variant="primary">Отправить</b-button></div>
  </div>  
      
  </div>

</template>

<style>
  @import 'https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css';
  @import 'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css';
  @import "~vue-snotify/styles/material.css";
  @import 'assets/css/fileicons.css';
  @import 'assets/css/main.css';
  @import 'assets/css/themes/darklight-blue.min.css';
  @import 'assets/css/widgets.min.css';
  @import 'assets/css/site.css'; 


</style>

<script>
    import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//import miniChat from './components/chat/miniChat'
import Navpanel from './components/layout/Navpanel'
import Navbar from './components/layout/Navbar'
import VmBackTop from 'vue-multiple-back-top'
export default {
  name: 'app',
      metaInfo: {
      title: 'Я-ЭКСПЕРТ || Социальная сеть экспертов национальной системы профессиональных квалификаций'
    },
  components: {
    Navpanel, 
    Navbar,
    VmBackTop
//    miniChat
  },
  data () {
    return {
      context: 'app context',
      loaded: false,
      coreData: {}
    }
  },
  mounted () {
    var _this = this
    // Set up $auth.ready with other arbitrary loaders (ex: language file).
    setTimeout(function () {
      _this.loaded = true
    }, 500)
  },
  created () {
    // var _this = this
    this.$moment.locale('ru')
    this.$moment.tz.setDefault("UTC");
    this.$auth.ready(function () {
      console.log('ready ' + this.context)
    })
  },
  methods: {
    logout () {
      this.$auth.logout({
        makeRequest: true,
        redirect: {name: 'Index'},
        success () {
          console.log('success ' + this.context)
        },
        error () {
          console.log('error ' + this.context)
          alert('Возникла ошибка')
        }
      })
    },
    unimpersonate () {
      this.$auth.unimpersonate({
        success () {
          console.log('success ' + this.context)
        },
        error () {
          console.log('error ' + this.context)
        }
      })
    }
  }
}
</script>
